import {
  Autocomplete,
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import Sidebar from "../../../components/sidebar/sidebar";
import { Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import { Formik, Form } from "formik";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  fetchCustomerGroupLoanCollectionReportService,
  fetchCustomerGroupPigmyCollectionReportService,
} from "../../../services/reportService";
import { getAllAgentsService } from "../../../services/agentService";
import { toast } from "react-toastify";
import moment from "moment";
import * as XLSX from "xlsx"; // Import XLSX for Excel export

function GroupPigmyCollectionReport() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loans, setLoans] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //   const [customer, setcustomer] = useState([]); // Assuming you will fetch the customer
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalCollections, setTotalCollections] = useState();
  const [agents, setAgents] = useState([]);
  const initialValues = {
    fromDate: null,
    toDate: null,
    frequency: "",
    status: "Pending",
    agent: "",
    customerName: "",
  };
  const [filters, setFilters] = useState(initialValues);
  const frequencies = ["daily", "weekly", "monthly"];
  const statuses = ["Pending", "Paid"];

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService(0, 50);
      setAgents(agents?.agentsWithPhoneContacts);
    } catch (err) {
      toast.error(err.message);
    }
  };

  //   const handleFilter = () => {
  //     fetchPigmy();
  //     // Fetch or filter customer based on fromDate and toDate
  //   };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchLoans = async (values) => {
    try {
      setLoading(true);
      const getLoans = await fetchCustomerGroupPigmyCollectionReportService(
        values.fromDate, // Formik values now being used
        values.toDate,
        page,
        rowsPerPage,
        values.frequency,
        values.status,
        values.agent,
        false,
        values.search
      );
      setLoans(getLoans?.groupCollections);
      //setExcelData(getLoans?.excelData);
      setTotalCollections(getLoans?.totalCollections); // Adjust this based on API response structure
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleExport = async () => {
    setExcelLoading(true);

    const getLoans = await fetchCustomerGroupPigmyCollectionReportService(
      filters.fromDate,
      filters.toDate,
      page,
      rowsPerPage,
      filters.frequency,
      filters.status,
      filters.agent,
      true
    );

    const excelData = getLoans?.excelData || [];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Group Pigmy Report");

    worksheet.columns = [
      { header: "SL.NO", key: "SL.NO", width: 8 },
      { header: "Group Name", key: "Group Name", width: 25 },
      { header: "Phone Number", key: "Phone Number", width: 14 },
      { header: "Agent Name", key: "Agent Name", width: 20 },
      { header: "Loan Code", key: "Loan Code", width: 14 },
      { header: "Frequency", key: "Frequency", width: 12 },
      { header: "Due Date", key: "Due Date", width: 14 },
      { header: "Collection Amount", key: "Collection Amount", width: 18 },
      { header: "Paid Amount", key: "Paid Amount", width: 15 },
      { header: "Collected Date", key: "Collected Date", width: 16 },
      { header: "Status", key: "Status", width: 12 },
    ];

    excelData.forEach((row, index) => {
      const formattedRow = {
        "SL.NO": index + 1,
        "Group Name": row?.group?.groupName || "",
        "Phone Number": row?.group?.groupLeaderPhoneNumber || "",
        "Agent Name": row?.agent?.userName || "",
        "Loan Code": row?.group?.groupCode || "",
        Frequency: row?.group?.frequency || "",
        "Due Date": moment(row?.dueDate).format("DD-MM-YYYY") || "",
        "Collection Amount": row?.collectionAmount || "",
        "Paid Amount": row?.paidAmount || "",
        "Collected Date": row?.collectionDate
          ? moment(row.collectionDate).format("DD-MM-YYYY")
          : "-",
        Status: row?.status || "",
      };

      const dataRow = worksheet.addRow(formattedRow);

      // Optional: style certain fields
      dataRow.getCell("Group Name").font = {
        bold: true,
        color: { argb: "FF6A1B9A" },
      };
      dataRow.getCell("Agent Name").font = {
        bold: true,
        color: { argb: "FF1E88E5" },
      };
      dataRow.getCell("Collection Amount").font = {
        bold: true,
        color: { argb: "FFC62828" },
      };
      dataRow.getCell("Paid Amount").font = {
        bold: true,
        color: { argb: "FF2E7D32" },
      };
      dataRow.getCell("Phone Number").font = {
        bold: true,
        color: { argb: "FF00897B" },
      };
    });

    // Header styling
    worksheet.eachRow((row, rowNum) => {
      row.eachCell((cell, colNum) => {
        if (rowNum === 1) {
          cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF5252FF" }, // header color
          };
          cell.alignment = { vertical: "middle", horizontal: "center" };
        } else {
          // Align based on column type
          const centerCols = [1, 5, 6, 7, 8, 9, 10, 11];
          const leftCols = [2, 3, 4];

          if (centerCols.includes(colNum)) {
            cell.alignment = { vertical: "middle", horizontal: "center" };
          } else if (leftCols.includes(colNum)) {
            cell.alignment = { vertical: "middle", horizontal: "left" };
          }
        }
      });
    });

    // Export the file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Group_Pigmy_Collection_Report.xlsx");

    setExcelLoading(false);
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  useEffect(() => {
    fetchLoans(filters); // fetch loans based on initial filter values
  }, [page, rowsPerPage]); // re-fetch loans on page or rowsPerPage change

  return (
    <>
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">
                Group Pigmy Collection Report
              </Typography>
            </Box>
            <Paper
              style={{
                color: "#000",
                padding: "20px",
                marginTop: 20,
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                // backgroundColor: "#f7f7ff",
              }}
            >
              <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                  setFilters(values);
                  fetchLoans(values); // Pass Formik values when filtering
                }}
              >
                {({ values, handleChange, setFieldValue }) => (
                  <Form>
                    <Box sx={{ p: 2 }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={2}>
                          <Typography>From Date</Typography>
                          <TextField
                            type="date"
                            name="fromDate"
                            size="small"
                            value={values.fromDate}
                            onChange={handleChange}
                            InputLabelProps={{
                              shrink: true, // This ensures that the label doesn't overlap with the value
                            }}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <Typography>To Date</Typography>
                          <TextField
                            type="date"
                            name="toDate"
                            size="small"
                            value={values.toDate}
                            onChange={handleChange}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            fullWidth
                          />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Frequency</Typography>
                            <Select
                              name="frequency"
                              value={values.frequency}
                              onChange={handleChange}
                              size="small"
                            >
                              {frequencies.map((freq) => (
                                <MenuItem key={freq} value={freq}>
                                  {freq}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Status</Typography>
                            <Select
                              size="small"
                              name="status"
                              value={values.status}
                              onChange={handleChange}
                            >
                              {statuses.map((status) => (
                                <MenuItem key={status} value={status}>
                                  {status}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <FormControl fullWidth>
                            <Typography>Agent</Typography>
                            <Select
                              size="small"
                              name="agent"
                              value={values.agent}
                              onChange={handleChange}
                            >
                              {agents.map((agent) => (
                                <MenuItem key={agent._id} value={agent._id}>
                                  {agent.userName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={2}>
                          <TextField
                            size="small"
                            label="Search Group Name"
                            fullWidth
                            onChange={(event) => {
                              setFieldValue("search", event.target.value);
                            }}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} textAlign="center">
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<i className="fas fa-filter"></i>}
                          >
                            {loading ? (
                              <CircularProgress
                                size={24}
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              "Generate"
                            )}
                          </Button>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={handleExport}
                            sx={{
                              mx: 2,
                              backgroundColor: "green",
                              color: "#fff",
                              "&:hover": { backgroundColor: "#006400" },
                            }}
                          >
                            {excelLoading ? (
                              <CircularProgress
                                size={24}
                                style={{ color: "#fff" }}
                              />
                            ) : (
                              "Download Excel"
                            )}
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Paper>
            <Box sx={{ mt: 2 }}>
              {" "}
              <TableContainer>
                <Table
                  sx={{
                    minWidth: 650,
                    borderCollapse: "separate",
                    borderSpacing: "0 8px",
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f3f4f6" }}>
                      {[
                        "SL.NO",
                        "Group Name",
                        "Agent Name",
                        "Phone Number",
                        "Pigmy Code",
                        "Frequency",
                        "Due Date",
                        "Collection Amount",
                        "Paid Amount",
                        "Collected Date",
                        "Status",
                      ].map((header) => (
                        <TableCell
                          key={header}
                          sx={{
                            color: "#5252ff",
                            padding: "6px",
                            fontWeight: "bold",
                            borderBottom: "1px solid #e0e0e0",
                            textAlign: "center",
                          }}
                        >
                          {header}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loans?.length > 0 ? (
                      loans.map((row, index) => {
                        const isOverdue =
                          new Date(row?.dueDate) < new Date() &&
                          row?.status === "Pending";
                        return (
                          <TableRow
                            key={row._id}
                            sx={{
                              backgroundColor: isOverdue
                                ? "#8B0000"
                                : index % 2 === 0
                                ? "#fafafa"
                                : "#ffffff",
                              color: isOverdue ? "#ffffff" : "inherit",
                              borderRadius: "8px",
                              boxShadow: 1,
                            }}
                          >
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.groupName}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.agent?.userName}
                            </TableCell>

                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.groupLeaderPhoneNumber}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.groupCode}
                            </TableCell>

                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.group?.frequency}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {moment(row?.dueDate).format("DD-MM-YYYY")}
                            </TableCell>

                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.collectionAmount}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.paidAmount}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.collectionDate
                                ? moment(row.collectionDate).format(
                                    "DD-MM-YYYY"
                                  )
                                : "-"}
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "6px",
                                textAlign: "center",
                                color: isOverdue ? "#ffffff" : "inherit",
                              }}
                            >
                              {row?.status}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={12}
                          sx={{ textAlign: "center", padding: "16px" }}
                        >
                          No loans available in table
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={totalCollections}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Show"
                sx={{
                  "& .MuiTablePagination-actions": { margin: "0 12px" },
                  mt: 2,
                }}
              />
            </Box>
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
      </div>
    </>
  );
}

export default GroupPigmyCollectionReport;
